// 浏览器信息
export const browser = {
  versions: (function () {
    const u = navigator.userAgent;
    return {
      // 移动终端浏览器版本信息
      trident: u.indexOf("Trident") > -1, // IE内核
      presto: u.indexOf("Presto") > -1, // opera内核
      webKit: u.indexOf("AppleWebKit") > -1, // 苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, // android终端或uc浏览器
      iPhone: u.indexOf("iPhone") > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, // 是否iPad
      webApp: u.indexOf("Safari") == -1 // 是否web应该程序，没有头部与底部
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
/*
 * 工具类
 */
/*
 * 时间戳日期格式化
 * @param date 日期
 * @param format 格式
 */
export function dateFormat(timestamp, format = "YYYY-MM-DD hh:mm:ss") {
  if (!timestamp) {
    return;
  } else {
    const addzero = (n) => {
      const nb = parseInt(n);
      if (typeof nb === "number" && !isNaN(nb)) {
        return n < 10 ? `0${nb}` : n;
      } else {
        return "00";
      }
    };
    const date = new Date(timestamp);
    const Y = date.getFullYear();
    const M = date.getMonth() + 1;
    const D = date.getDate();

    const h = date.getHours();
    const m = date.getMinutes();
    const s = date.getSeconds();
    return format
      .replace("YYYY", Y)
      .replace("MM", addzero(M))
      .replace("DD", addzero(D))
      .replace("hh", addzero(h))
      .replace("mm", addzero(m))
      .replace("ss", addzero(s));
  }
}

/*
 * 读取图片为base64
 * @param file 文件
 * @param loaded 成功回调函数
 * @param loadfailed 失败回调函数
 */
export function readImageToBase64(file, loaded, loadfailed) {
  // 读取图片转换为base64代码
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (loaded) {
        loaded(e.target.result);
      }
    };
    reader.onerror = () => {
      if (loadfailed) {
        loadfailed("获取图片失败");
      }
    };
    reader.readAsDataURL(file, "UTF-8");
  }
}
/*
 * 画布输出base64
 * @param canvas 画布对象
 * @param type 图片类型
 */
export function canvasToBase64(canvas, type = "png") {
  return canvas.toDataURL(`image/${type}`);
}

/*
 * 校验上传
 * @param file 文件
 * @param size 文件
 * @param type 文件    // 0图片，1文件，2音频 3视频 4文档 5压缩文件
 * @param typestr 文件 // 可接受的文件类型 -1无限制
 * @param callback 回调函数
 */
export function checkUploadFile(options, callback) {
  const file = options.file;
  const size = options.size || 2;
  const type = options.type || 0;
  let accept = String(
    options.typestr ? options.typestr : ".png,.jpg,.jpeg"
  ).toLocaleLowerCase();
  let allow = true;
  if (type == 0) {
    const isLimitType =
      accept.indexOf(file.type.replace(/image\//g, "")) !== -1;
    if (!isLimitType) {
      const msg = `请选择${options.typestr}类型的图片`;
      if (callback) {
        callback(msg);
      } else {
        alert(msg);
      }
      allow = false;
      return allow;
    }
  }else if(type == 2){
    accept = 'audio/mpeg,audio/wav,audio/ogg';
    const isLimitType = accept.indexOf(file.type) !== -1;
    if (!isLimitType) {
      const msg = `请选择${options.typestr}类型的音频`;
      if (callback) {
        callback(msg);
      } else {
        alert(msg);
      }
      allow = false;
      return allow;
    }
  }else if(type==3){
    accept = 'video/x-msvideo,video/mp4,video/quicktime'
    const isLimitType = accept.indexOf(file.type) !== -1;
    if (!isLimitType) {
      const msg = `请选择${options.typestr}类型的视频`;
      if (callback) {
        callback(msg);
      } else {
        alert(msg);
      }
      allow = false;
      return allow;
    }
  }else if(type == 4){
    accept = 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    const isLimitType = accept.indexOf(file.type) !== -1;
    if (!isLimitType) {
      const msg = `请选择${options.typestr}类型的文档`;
      if (callback) {
        callback(msg);
      } else {
        alert(msg);
      }
      allow = false;
      return allow;
    }
  }else if(type == 5){
    accept = '.zip,.rar,application/zip,application/x-zip-compressed,application/x-rar-compressed'
    const isLimitType = accept.indexOf(file.type) !== -1;
    if (!isLimitType) {
      const msg = `请选择${options.typestr}类型的文档`;
      if (callback) {
        callback(msg);
      } else {
        alert(msg);
      }
      allow = false;
      return allow;
    }
  }
  if (type == 1 && accept != -1) {
    let typestr = getFileType(file.name);
    const isLimitType = accept.indexOf(typestr) !== -1;
    if (!isLimitType) {
      const msg = `请选择${accept}类型的文件`;
      if (callback) {
        callback(msg);
      } else {
        alert(msg);
      }
      allow = false;
      return allow;
    }
  }
  const isLimitSize = file.size < size * 1024 * 1024;
  if (!isLimitSize) {
    const msg = `请选择小于${size}MB的${
      type == 0 ? "图片" : type == 1 ? "文件" : "资源文件"
    }`;
    if (callback) {
      callback(msg);
    } else {
      alert(msg);
    }
    allow = false;
    return allow;
  }
  return allow;
}
export function getFileType(fileName) {
  return fileName.slice(-(fileName.length - fileName.lastIndexOf(".") - 1));
}
// 输出带有 , 的number
export function formatNumber(n) {
  if (parseInt(n) == 0 || !n) {
    return 0;
  }
  var b = parseInt(n).toString();
  var len = b.length;
  if (len <= 3) {
    return b;
  }
  var r = len % 3;
  return r > 0
    ? b.slice(0, r) + "," + b.slice(r, len).match(/\d{3}/g).join(",")
    : b.slice(r, len).match(/\d{3}/g).join(",");
}
// 校验过期
export function expiredChecked(temp) {
  const now = Date.parse(new Date()) / 1000;
  const ex = now >= parseInt(temp);
  return ex;
}
/**
 * @description: 解析url 参数
 * @param {*} URL
 * @return {obj}  返回参数对象
 * @author: wangxiaoheng
 */
export function queryObj(URL){
  var obj = {},
  reg = /([^?&#+]+)=([^?&#+]+)/g;
  URL.replace(reg,function($0,$1,$2){
    obj[$1] = $2;
  })
  return obj
}

export function getfileTypeArr(imgArr){
  let imgsArr = []
  for(let i in imgArr){
    let imgs = {
      fileName:'',
      fileUrl:imgArr[i],
      url:imgArr[i],
      fileType:'',
      formatInfo:null,
      photo_file_list:[{
        url:imgArr[i],
        status: "done",
      }]
    }
    imgs.fileName = imgs.fileUrl.match(/\/([^\/?#]+)[^\/]*$/)[1];
    let url=imgArr[i]
    url=url.toLowerCase()
    if(url.includes('jpeg')||url.includes('jpg')||url.includes('png')){
      imgs.fileType=1//图片
      imgs.formatInfo = 'image/jpeg,image/png,image/jpg'
    }
    if(url.includes('mp3')||url.includes('wav')||url.includes('ogg')){
      imgs.fileType=2//音频
      imgs.formatInfo = '.mp3,.wav,.ogg,.mpeg'
    }
    if(url.includes('mp4')||url.includes('avi')||url.includes('mov')){
      imgs.fileType=3 //视频
      imgs.formatInfo = '.mp4,.avi,.mov'
    }
    if(url.includes('docx')||url.includes('doc')){
      imgs.fileType=4 //文档
      imgs.formatInfo = '.doc,.docx'
    }
    if(url.includes('.zip')||url.includes('.rar')){
      imgs.fileType=5 //压缩文件
      imgs.formatInfo = '.zip,.rar,application/zip,application/x-rar-compressed'
    }
    imgsArr.push(imgs)
  }
  return imgsArr
}
export function getfileTypeSuffix(kType){
    let formatInfo = "";
    if (kType == 1) {
      formatInfo = "image/jpeg,image/png,image/jpg";
    } else if (kType == 2) {
      formatInfo = ".mp3,.wav,.ogg,.mpeg";
    } else if (kType == 3) {
      formatInfo = ".mp4,.avi,.mov";
    } else if (kType == 4) {
      formatInfo = ".doc,.docx";
    } else if (kType == 5) {
      formatInfo = ".zip,.rar";
    }
    return formatInfo
}
export function getfileTypeName(type){
    let name = "";
    if (type == 1) {
      name = "图片文件";
    } else if (type == 2) {
      name = "音频文件";
    } else if (type == 3) {
      name = "视频文件";
    } else if (type == 4) {
      name = "文档文件";
    } else if (type == 5) {
      name = "压缩文件";
    }
    return name
}
